module.exports = __webpack_public_path__ + "img/CersoTears.9798a3a3.png";